// extracted by mini-css-extract-plugin
module.exports = {"not-found":"PJO-W-","notFound":"PJO-W-"};